﻿import { fromEvent, map } from "rxjs";

export default class RealtorDropdown {
  constructor() {
    this.selectedValue = '';
    this.required = false;
    this.errorMessageId = 'nhs_ErrorForRealtorQuestion';
    this.errorCssClass = 'error'
    this.id = 'nhs-real-agent';
    this.errorMessage = `<span id="${this.errorMessageId}" class="form__error" hidden>
                           Please make a selection
                         </span>`;
    this.label = `<label for="${this.id}" data-qa="realtorText">Are you working with a real estate agent?</label>`;
  }

  set value(newValue) {
    this.selectedValue = newValue || ''; 
    const realtorDropdown = this.getNode();
    if (realtorDropdown) {
      realtorDropdown.value = this.selectedValue;
    }
  }

  get value() {
    return this.selectedValue;
  }

  getHtml() {
    return `${this.label} 
      <div>
        <select id="${this.id}" class="form__select" autocomplete="off" name="realtorQuestion" data-qa="realtorQuestion" 
        ${this.required ? 'required' : ''}>
          <option value="" style="display: none;">Please select an answer</option>
          <option class="nhs-real-agent-option" value="1" data-qa="realtorQuestionOne">I am buying without an agent</option>
          <option class="nhs-real-agent-option" value="2" data-qa="realtorQuestionTwo">I am working with an agent</option>
          <option class="nhs-real-agent-option" value="3" data-qa="realtorQuestionThree">I am a real estate agent</option>
          <option class="nhs-real-agent-option" value="4" data-qa="realtorQuestionFour">I don't know yet</option>
        </select>
        ${this.errorMessage}
      </div>`;
  }

  getNode() {
    return document.getElementById(this.id);
  }
  
  /**
   * setSelectedValue: Finds the correct index based on the selectedValue
   * and updates the select element.
   */
  setSelectedValue() {
    const realtorDropdownNode = this.getNode();
    if (realtorDropdownNode) {
      const optionsArray = Array.from(realtorDropdownNode.options);
      realtorDropdownNode.selectedIndex = optionsArray.findIndex(
        (option) => option.value === this.selectedValue
      );
    }
  }

  /**
   * getOnChangeEvent: On select change map its value to the storage property.
   */
  getOnChangeEvent() {
    return fromEvent(this.getNode(), 'change').pipe(
      map((event) => {
        this.value = event.target.value;
        return { realtorQuestion: this.selectedValue };
      })
    );
  }

  /**
   * Method to remove the required attribute.
   */

  removeRequired() {
    const node = this.getNode();
    node.removeAttribute('required');
  }

  setInvalidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.setAttribute('aria-invalid', true);
    node.classList.add(this.errorCssClass);
    errorMessage.removeAttribute('hidden');
  }

  /**
   * Method to set the required attribute.
   */

  setRequired() {
    const node = this.getNode();
    node.setAttribute('required', 'true');
  }

  setValidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.removeAttribute('aria-invalid');
    node.classList.remove(this.errorCssClass);
    errorMessage.setAttribute('hidden', true);
  }

  isValid() {
    const node = this.getNode();
    const isEmpty = node.value === '';
    const isRequired = node.required;
    
    // If it is empty and is required, the input is not valid
    if(isEmpty && isRequired) {
      return false;
    }

    return true;
  }

  validate() {
    const node = this.getNode();
    const isValid = this.isValid();

    if (isValid) {
      this.setValidState(node);
    } else {
      this.setInvalidState(node);
    }

    return isValid;
  }
}
